import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // If we get a 401 Unauthorized, the token is invalid
      if (error.status === 401) {
        // Clear the token and redirect to login
        localStorage.removeItem('auth_token');
        
        // Only redirect if not already on login/register pages
        const currentUrl = router.url;
        if (!currentUrl.includes('/login') && !currentUrl.includes('/register')) {
          router.navigate(['/login']);
        }
      }
      
      return throwError(() => error);
    })
  );
};

